import(/* webpackMode: "eager" */ "/opt/render/project/src/src/app/global-error.js");
